import { SCOPE_STORAGE_KEY } from '../constants/scope';

/**
 * The currently-selected node id, read from localStorage (NodeContext keeps it synced under this
 * key). Node-scoped adapters call this at request time so the shared pages stay node-unaware.
 *
 * `null` means All Sites — which is also what a fresh browser and a fresh login start on.
 */
export function selectedNodeId(): string | null {
  return localStorage.getItem(SCOPE_STORAGE_KEY);
}
